import { types } from '../reducers/additionalMetadataReducer';

// eslint-disable-next-line import/prefer-default-export
export const createAdditionalMetadata = (values) => ({
  type: types.POST,
  payload: values,
});

export const updateAdditionalMetadata = (values, dictionaryIndex) => ({
  type: types.PUT,
  payload: values,
  dictionaryIndex,
});

export const removeAdditionalMetadata = (item) => ({
  type: types.DELETE,
  item,
});

export const reloadAdditionalMetadata = (items) => ({
  type: types.RELOAD,
  payload: items,
});

export const resetAdditionalMetadata = () => ({
  type: types.RESET,
});

export { getDraftId } from '../reducers/additionalMetadataReducer';
